module.exports = __webpack_public_path__ + "media/pick-answer-merged.71814986.webm";